export const P1 = 'White';
export const P2 = 'Black';

export const WIN = 'WIN';
export const DRAW = 'DRAW';
export const UNFINISHED = 'UNFINISHED';
